module.exports = {"id":"205083","name":"Fayçal Fajr","rating":"75","photo":"./data/images/photos/4/205083.png","club":{"name":"Getafe CF","logo":"./data/images/clubs/GetafeCF.png"},"positions":["MD","MG","MOC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FaycalFajr0.json
// module id = 1371
// module chunks = 0